import React, { useState } from "react";
import { Play, X } from "lucide-react";
import { getPortalUrl } from "../../../config/domains";
import onboardingPlaceholder from "../../../images/onboarding-video-placeholder.png";

const HeroSection = ({
  heroTitle = "Welcome To NKENNEAI API",
  heroSubtitle = "Watch this quick 2-minute onboarding video to get started.",
  buttonText = "Get API Access",
}) => {
  const [isWatchMode, setIsWatchMode] = useState(false);

  // Video Configuration - you can update this with your actual onboarding video ID
  const videoId = "gdAUZPOdd7M"; // Update with your actual video ID
  const watchParams = "autoplay=1&mute=0&controls=1&showinfo=0&rel=0&modestbranding=1";

  return (
    <div className="relative bg-[#1E6C56] rounded-2xl overflow-hidden mb-6">
      {/* Circular Overlays */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white/10 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full translate-x-1/3 -translate-y-1/3"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-white/10 rounded-full translate-x-1/4 translate-y-1/4"></div>

      {/* Video/Image Background Section */}
      <div className="relative w-full h-[500px] md:h-[600px] rounded-xl overflow-hidden group">
        {/* Background Content */}
        <div className={`absolute inset-0 z-0 transition-all duration-700`}>
          {isWatchMode ? (
            <iframe
              className="w-full h-full object-cover"
              src={`https://www.youtube.com/embed/${videoId}?${watchParams}`}
              title="NKENNEAI API Documentation Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              frameBorder="0"
            ></iframe>
          ) : (
            <img
              src={onboardingPlaceholder}
              alt="API Documentation Preview"
              className="w-full h-full object-cover"
            />
          )}

          {/* Dark Overlay for better text readability - only show when not in watch mode */}
          {!isWatchMode && <div className="absolute inset-0 bg-black/30"></div>}
        </div>

        {/* Text Content Overlay - Bottom Left */}
        {!isWatchMode && (
          <div className="absolute bottom-0 left-0 z-20 p-6 md:p-12 lg:p-16">
            <div className="max-w-2xl">
              <h2 className="text-2xl md:text-4xl lg:text-3xl font-black text-white leading-tight mb-4">
                {heroTitle}
              </h2>
              <p className="text-base md:text-md text-white mb-6">
                {heroSubtitle}
              </p>
              {/* CTA Button */}
              <a
                href={getPortalUrl("/user-dashboard/developer-tools")}
                className="inline-block bg-white text-black font-bold px-6 py-3 rounded-2xl transition-all duration-300 transform hover:scale-105 shadow-lg"
              >
                {buttonText}
              </a>
            </div>
          </div>
        )}

        {/* Close Button for Watch Mode */}
        {isWatchMode && (
          <button
            onClick={() => setIsWatchMode(false)}
            className="absolute top-4 right-4 z-50 bg-white/10 hover:bg-white/20 backdrop-blur-md p-2 rounded-full text-white transition-all duration-300 transform hover:scale-110"
          >
            <X size={20} />
          </button>
        )}

        {/* Play Button Overlay - Center */}
        {!isWatchMode && (
          <div className="absolute inset-0 z-10 flex items-center justify-center">
            <button
              onClick={() => setIsWatchMode(true)}
              className="bg-[#F5C956] hover:bg-[#E5B946] rounded-full p-6 transition-all duration-300 transform hover:scale-110 shadow-lg"
            >
              <Play size={28} fill="#000000" className="text-black ml-1" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeroSection;
